import { useEffect, useState } from 'react';

// Sum of green area: top-bar + inputs + filters
const SMALL_SCREEN_HEADER_HEIGHT = 235;

export const useForceShow = (skip: boolean): boolean => {
  const [forceShow, setForceShow] = useState(false);

  useEffect(() => {
    if (skip) {
      return;
    }

    const calculateScroll = (): void => {
      const remainingScroll =
        document.documentElement.scrollHeight -
        window.scrollY -
        window.innerHeight;

      setForceShow(SMALL_SCREEN_HEADER_HEIGHT > remainingScroll);
    };

    // We need a timeout to ensure the scroll value is correct
    setTimeout(() => {
      calculateScroll();
    }, 1000);

    window.addEventListener('scroll', calculateScroll);
    return () => {
      window.removeEventListener('scroll', calculateScroll);
    };
  }, [skip]);

  return forceShow;
};
